export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create.vue?vue&type=template&id=b8234e3e"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/content/strings/create.vue?vue&type=template&id=b8234e3e
// module id = xJac
// module chunks = 0